export default __webpack_public_path__ + "static/media/mail (1).57550167.svg";